/* ================================================================
   MEGA MENU JS — assets/mega-menu.js
   Paste this file once. Handles dynamic product loading on hover.
   ================================================================ */

(function () {
  'use strict';

  var cache = {}; // Cache fetched products to avoid repeat requests
  var currentController = null; // Track active fetch request

  function init() {
    var subLinks = document.querySelectorAll('.cbp-sub-link');
    if (!subLinks.length) return;

    subLinks.forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        var handle = this.getAttribute('data-collection');
        if (!handle || handle === '') return;

        var navItem = this.closest('.cbp-nav-item');
        if (!navItem) return;

        // Set active state on sub-links
        navItem.querySelectorAll('.cbp-sub-link').forEach(function (l) {
          l.classList.remove('cbp-active');
        });
        this.classList.add('cbp-active');

        // Find containers
        var grid = navItem.querySelector('.cbp-products-grid');
        var viewAllBtn = navItem.querySelector('.cbp-view-all');
        if (!grid) return;

        // Update View All link immediately
        if (viewAllBtn) {
          viewAllBtn.href = '/collections/' + handle;
        }

        // If already cached, render immediately
        if (cache[handle]) {
          renderProducts(grid, cache[handle]);
          return;
        }

                // Cancel any previous in-flight request
        if (currentController) {
          currentController.abort();
        }

        // Fetch products from Shopify AJAX API
        grid.classList.add('cbp-loading');

        currentController = new AbortController();
        var signal = currentController.signal;

        fetch('/collections/' + handle + '/products.json?limit=4', { signal: signal })
          .then(function (res) {
            if (!res.ok) throw new Error('Network error');
            return res.json();
          })
          .then(function (data) {
            grid.classList.remove('cbp-loading');
            if (!data.products || !data.products.length) {
              grid.innerHTML = '<div class="cbp-no-products">No products found</div>';
              return;
            }
            cache[handle] = data.products;
            renderProducts(grid, data.products);
          })
          .catch(function (err) {
            if (err.name === 'AbortError') return;
            grid.classList.remove('cbp-loading');
          });
      });
    });

    // Set first sub-link as active by default when dropdown opens
    document.querySelectorAll('.cbp-nav-item.has-mega').forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        var firstSub = this.querySelector('.cbp-sub-link');
        if (firstSub && !this.querySelector('.cbp-sub-link.cbp-active')) {
          firstSub.classList.add('cbp-active');
        }
      });
      item.addEventListener('mouseleave', function () {
        this.querySelectorAll('.cbp-sub-link').forEach(function (l) {
          l.classList.remove('cbp-active');
        });
      });
    });
  }

  function renderProducts(grid, products) {
    grid.innerHTML = products.slice(0, 4).map(function (p) {
      var img = p.images && p.images[0]
        ? '<div class="cbp-product-img-wrap"><img src="' + p.images[0].src + '" alt="' + escAttr(p.title) + '" loading="lazy"></div>'
        : '<div class="cbp-product-img-wrap cbp-product-no-img"></div>';

      var price = formatMoney(p.variants[0].price);
      var comparePrice = p.variants[0].compare_at_price
        ? '<span class="cbp-price-was">' + formatMoney(p.variants[0].compare_at_price) + '</span>'
        : '';

      return '<a href="/products/' + p.handle + '" class="cbp-product-card">'
        + img
        + '<p class="cbp-product-name">' + esc(p.title.substring(0, 32)) + '</p>'
        + '<p class="cbp-product-price"><span class="cbp-price-sale">' + price + '</span>' + comparePrice + '</p>'
        + '</a>';
    }).join('');
  }

  function formatMoney(price) {
  // Shopify /products.json returns price as decimal string, e.g. "199.00"
  var amount = parseFloat(price);
  return '₹' + amount.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  function esc(str) {
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  function escAttr(str) {
    return str.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();